module.exports = __webpack_public_path__ + "media/components/home/masthead/img/lavakidneys_1680x400-97a5ae4b3aeb639c694300169b783d57.jpg";